"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _Icon = _interopRequireDefault(require("../Icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  right: 0;\n  transition: transform 0.5s cubic-bezier(0.4, 0.2, 0, 1);\n  transform: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  left: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  top: 0;\n  pointer-events: none;\n  justify-content: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  border: none;\n  padding: 0\n    ", "px\n    0\n    ", "px;\n  box-sizing: border-box;\n  font-size: inherit;\n  text-align: left;\n  color: ", ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  overflow: hidden;\n  height: ", "px;\n  font-size: ", "px;\n  border: 1px solid\n    ", ";\n  border-radius: 8px;\n  background-color: ", ";\n  user-select: none;\n  touch-action: manipulation;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ICON_WIDTH = 40;
var BUTTON_PADDING_X = 36;

var Wrapper = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var height = _ref.height;
  return height === 'short' ? (0, _themeGet.themeGet)('buttonHeight.2') : height === 'tall' ? (0, _themeGet.themeGet)('buttonHeight.0') : (0, _themeGet.themeGet)('buttonHeight.1');
}, function (_ref2) {
  var height = _ref2.height;
  return height === 'short' ? (0, _themeGet.themeGet)('buttonFontSize.0') : height === 'tall' ? (0, _themeGet.themeGet)('buttonFontSize.2') : (0, _themeGet.themeGet)('buttonFontSize.1');
}, function (_ref3) {
  var error = _ref3.error;
  return !!error ? (0, _themeGet.themeGet)('colors.red500') : (0, _themeGet.themeGet)('colors.grey300');
}, (0, _themeGet.themeGet)('colors.white'));

var Button = _styledComponents["default"].button(_templateObject2(), (0, _themeGet.themeGet)('colors.white'), function (_ref4) {
  var hideTrailingIcon = _ref4.hideTrailingIcon;
  return hideTrailingIcon ? (0, _themeGet.themeGet)('space.3') : BUTTON_PADDING_X;
}, function (_ref5) {
  var leadingIconProps = _ref5.leadingIconProps;
  return leadingIconProps ? BUTTON_PADDING_X : (0, _themeGet.themeGet)('space.3');
}, function (_ref6) {
  var showPlaceholder = _ref6.showPlaceholder;
  return showPlaceholder ? (0, _themeGet.themeGet)('colors.grey500') : (0, _themeGet.themeGet)('colors.grey900');
});

var iconStyle = (0, _styledComponents.css)(_templateObject3());
var iconAttrs = {
  width: ICON_WIDTH,
  height: '100%'
};
var LeadingIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs(iconAttrs)(_templateObject4(), iconStyle);
var TrailingIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs(iconAttrs)(_templateObject5(), iconStyle, function (_ref7) {
  var focused = _ref7.focused;
  return focused && 'rotateX(180deg)';
});

var DropdownButton = function DropdownButton(_ref8) {
  var children = _ref8.children,
      onFocusChange = _ref8.onFocusChange,
      onClick = _ref8.onClick,
      focused = _ref8.focused,
      height = _ref8.height,
      dropdownId = _ref8.dropdownId,
      placeholder = _ref8.placeholder,
      inputProps = _ref8.inputProps,
      error = _ref8.error,
      leadingIconProps = _ref8.leadingIconProps,
      hideTrailingIcon = _ref8.hideTrailingIcon,
      props = (0, _objectWithoutProperties2["default"])(_ref8, ["children", "onFocusChange", "onClick", "focused", "height", "dropdownId", "placeholder", "inputProps", "error", "leadingIconProps", "hideTrailingIcon"]);
  var searchInputProps = inputProps || props.label && props.label.props;
  var buttonProps = {
    id: "".concat(dropdownId, "btn"),
    height: height,
    showPlaceholder: placeholder && placeholder === children,
    leadingIconProps: leadingIconProps,
    hideTrailingIcon: hideTrailingIcon,
    role: searchInputProps ? 'combobox' : null,
    'aria-controls': "".concat(dropdownId, "list"),
    'aria-owns': "".concat(dropdownId, "list"),
    'aria-haspopup': 'listbox',
    'aria-expanded': focused ? 'true' : 'false',
    'aria-label': placeholder || 'Ver lista',
    onMouseDown: function onMouseDown() {
      return setTimeout(onFocusChange, 0);
    },
    onClick: onClick
  };

  if (searchInputProps) {
    buttonProps = _objectSpread({}, buttonProps, {}, searchInputProps);
  }

  return _react["default"].createElement(Wrapper, {
    height: height,
    error: error
  }, leadingIconProps && _react["default"].createElement(LeadingIcon, (0, _extends2["default"])({
    size: height === 'short' ? 12 : 16
  }, leadingIconProps)), searchInputProps ? _react["default"].createElement(Button, (0, _extends2["default"])({
    as: "input",
    placeholder: placeholder
  }, buttonProps)) : _react["default"].createElement(Button, (0, _extends2["default"])({
    type: "button"
  }, buttonProps), children), !hideTrailingIcon && _react["default"].createElement(TrailingIcon, {
    focused: focused ? 1 : 0,
    name: "chevron-down",
    color: "dark",
    size: height === 'short' ? 12 : 16
  }));
};

DropdownButton.displayName = 'DropdownButton';
var _default = DropdownButton;
exports["default"] = _default;